(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector(".swiper--multicolumn");

	const initSlider = () => {
		multicolumnSwipeEnabled.classList.add("multicolumn-swiper-wrapper");
		const slides = document.querySelectorAll(".multicolumn-list__item");

		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});

		// Ajouter dynamiquement la pagination si elle n'existe pas
		let paginationEl = multicolumnSwipeEnabled.querySelector(".swiper-pagination");
		if (!paginationEl) {
			paginationEl = document.createElement("div");
			paginationEl.classList.add("swiper-pagination");
			multicolumnSwipeEnabled.appendChild(paginationEl);
		}

		// Initialisation Swiper
		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
			loop: false,
			slidesPerView: 1,

			// PAGINATION
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},

			// NAVIGATION (sera cachée en CSS sur mobile)
			navigation: {
				nextEl: ".multicolumn-button-next",
				prevEl: ".multicolumn-button-prev",
			},
		});
	};

	const destroySlider = () => {
		multicolumnSwipeEnabled.classList.remove("multicolumn-swiper-wrapper");
		const slides = document.querySelectorAll(".multicolumn-list__item");

		if (swiperMulticolumn) {
			swiperMulticolumn.destroy(true, true);
			swiperMulticolumn = undefined;
		}

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			// Mobile → activer slider
			if (entry.contentRect.width < 990 && multicolumnSwipeEnabled) {
				if (!swiperMulticolumn) {
					initSlider();
				}
			} 
			// Desktop → désactiver slider
			else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	
	initMulticolumn();

	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
	});
})();
